<template>
	<DjBox class="pt-5 md:pt-8 px-5 md:px-10 pb-5 md:pb-10">
		<h3 class="text-lg md:text-xl font-medium mb-4">{{ title }}</h3>
		<div v-for="(benefit, index) in data" :key="index" class="flex flex-col">
			<span v-if="benefit.langKey != 'other'" class="font-medium my-4">{{ langs[benefit.langKey][locale] }}</span>
			<div v-if="benefit.langKey == 'other'" class="list-style my-4" v-html="benefit.data[0].name[locale]"></div>
			<div v-else class="flex flex-wrap text-sm">
				<span v-for="(tag, index) in benefit.data" :key="index">
					{{ tag.name[locale] }}
					<span v-if="index != benefit.data.length - 1" class="mx-2 my-4">|</span>
				</span>
			</div>
			<div v-if="index != data.length - 1" class="h-[1px] w-full bg-dj-gray-light mt-4"></div>
		</div>
	</DjBox>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

type BData = {
	langKey: string;
	data: [
		{
			name: {
				en: string;
				hu: string;
				ro: string;
			};
		}
	];
};

export default defineComponent({
	name: "DjBoxBenefits",
	props: {
		title: {
			type: String,
			default: "title",
		},
		data: {
			type: Array as PropType<BData[]>,
			required: true,
		},
		locale: {
			type: String,
			default: "hu",
		},
		langs: {
			type: Object,
			required: true,
		},
	},
});
</script>

<style>
.list-style ul,
ol {
	padding-left: 1.2rem;
}

.list-style ul li {
	list-style-type: disc;
}
.list-style ol li {
	list-style-type: decimal;
}
</style>
